import type { BrandPageQuery, BrandPageQueryVariables } from 'src/types';
import brandPageQuery from '../query.graphql';
import { usePageQuery } from 'src/hooks/use-page-query';

export function useBrandPageQuery(variables: BrandPageQueryVariables) {
  return usePageQuery<BrandPageQuery>({
    query: brandPageQuery,
    routeName: 'brand',
    variables,
  });
}
